import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Common.css';

import Audi from '../../assets/audi.png';
import Mercedes from '../../assets/mercedes.png';
import BMW from '../../assets/vmw.png';
import Volvo from '../../assets/volvo.png';
import Porsche from '../../assets/porshe.png';
import Wols from '../../assets/wols.png';
import logo from '../../assets/bg_logo.png';
import { MdAddCall } from "react-icons/md";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation(); // detectăm schimbarea paginii

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 🔹 Când se schimbă ruta, închidem meniul mobil
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const carBrands = [
    { name: 'Audi', logo: Audi },
    { name: 'BMW', logo: BMW },
    { name: 'Mercedes', logo: Mercedes },
    { name: 'Porsche', logo: Porsche },
    { name: 'Volkswagen', logo: Wols },
    // { name: 'Volvo', logo: Volvo },
  ];

  return (
    <>
      {/* Top bar */}
      <div className="top-bar">
        <div className="container">
          <div className="contact-info">
            <MdAddCall style={{ color: 'white', fontSize: '27px' }} />
            <span className="contact-text">dlcautocenter1@gmail.com</span>
            <a href="tel:+40742032575" className="phone-number">
              +40 770 905 087
            </a>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-wrapper">
            {/* Logo */}
            <div className="logo">
              <Link to="/" className="logo-content">
                <img style={{ width: '75px' }} src={logo} alt="DLC Auto Center" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <ul className="nav-menu desktop-menu">
              <li><Link to="/" className="nav-link">Acasă</Link></li>
              <li><Link to="/stock" className="nav-link">Stoc Mașini</Link></li>
              <li><Link to="/contact" className="nav-link">Contact</Link></li>
              <li><a href="https://wa.me/40770905087" target="_blank" rel="noreferrer" className="nav-link">WhatsApp</a></li>
              <li><a href="tel:+40770905087" className="nav-link">Sună acum!</a></li>
            </ul>

            <Link to="/stock" className="view-cars-btn desktop-only">
              Vezi toate mașinile
            </Link>

            <Link to="tel:+40760 559 464" className="view-cars-btn desktop-only">
              Telefon
            </Link>

            {/* Mobile Menu Button */}
            <button
              className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <div
        className={`mobile-menu-overlay ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
      ></div>

      {/* Mobile Menu */}
     <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
  {isMenuOpen && (
    <button className="mobile-menu-close" onClick={toggleMenu} aria-label="Închide meniul">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </button>
  )}

  <ul className="mobile-nav-list">
    <li><Link to="/" className="mobile-nav-link" onClick={toggleMenu}>Acasă</Link></li>
    <li><Link to="/stock" className="mobile-nav-link" onClick={toggleMenu}>Stoc Mașini</Link></li>
    <li><Link to="/contact" className="mobile-nav-link" onClick={toggleMenu}>Contact</Link></li>
    <li><a href="https://wa.me/40770905087" target="_blank" rel="noreferrer" className="mobile-nav-link">WhatsApp</a></li>
    <li><a href="tel:+40770905087" className="mobile-nav-link">Sună acum!</a></li>
  </ul>

  <Link to="/stock" className="view-cars-btn mobile-view-btn" onClick={toggleMenu}>
    Vezi toate mașinile 
  </Link>

  <Link style={{marginTop:'25px', backgroundColor:'black'}} to="tel:+40760 559 464" className="view-cars-btn mobile-view-btn">
              Telefon
   </Link>
</div>


      {/* Car Brands Section */}
      <div className="car-brands-section">
        <div className="container">
          <div className="brands-wrapper">
            {carBrands.map((brand, index) => (
              <div key={index} className="brand-item">
                <div className="brand-logo">
                  <img src={brand.logo} alt={brand.name} />
                </div>
                <span className="brand-name">{brand.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
